import { useEffect, useState } from "react";
import { isAlwaysOnTop, isTauri, toggleAlwaysOnTop } from "../tauri";

/** Native-window affordances. Renders ONLY when running inside the Tauri
 * shell — in browser mode the component returns null so the dashboard
 * header stays identical to its historical layout.
 *
 * Slice 1 ships the always-on-top toggle (the L9 trigger condition). System
 * tray and global hotkeys are slice-2 candidates. */
export function TauriWindowControls() {
  const [pinned, setPinned] = useState<boolean>(false);
  const [available, setAvailable] = useState<boolean>(false);

  useEffect(() => {
    if (!isTauri()) return;
    setAvailable(true);
    isAlwaysOnTop().then((state) => {
      if (state !== null) setPinned(state);
    });
  }, []);

  if (!available) return null;

  const onClick = async () => {
    const next = await toggleAlwaysOnTop();
    if (next !== null) setPinned(next);
  };

  return (
    <button
      onClick={onClick}
      title={pinned ? "Always-on-top: ON (click to unpin)" : "Click to pin window on top"}
      aria-pressed={pinned}
      className={
        "px-2 py-1 rounded text-xs font-mono uppercase border " +
        (pinned
          ? "bg-success/20 border-success text-success"
          : "bg-surface-2 border-border text-fg-muted hover:text-fg")
      }
    >
      {pinned ? "📌 pinned" : "📌 pin"}
    </button>
  );
}
